// jQuery
import jquery from 'jquery';

window.jQuery = jquery;
window.$ = jquery;

// Bootstrap
require('./plugins/bootstrap.min');

// Cookie
require('./plugins/jquery.cookie');

// Masked input
import './plugins/inputmask.min';

// Slick slider
import './plugins/slick.min';

// Lightbox
require('./plugins/lightbox.min');

// Images loaded
const imagesLoaded = require('imagesloaded');
imagesLoaded.makeJQueryPlugin($);

// mCustomScrollbar loaded
require('malihu-custom-scrollbar-plugin')($);

require('./plugins/rcrop.min');

// Scripts
require('./scripts/scripts.js');
